<template>
  <div>
    <v-dialog v-model="dialog" max-width="900" persistent scrollable>

      <v-card>

        <v-card-title>
          Cadeaux Physiques
          <v-spacer/>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-10">

          <!-- FORM -->
          <v-row class="bg-light rounded-lg mx-2 pa-4" align="start">

            <v-col cols="12" md="4">
              <v-text-field v-model="form.name"
                            outlined
                            dense
                            hide-details="auto"
                            :error-messages="formErrors.name"
                            label="Nom *"
              />
            </v-col>

            <!-- points_or_physical -->
            <template v-if="giftType === 'points_or_physical'">
              <v-col cols="6" md="2">
                <v-text-field v-model="form.quantity"
                              outlined
                              dense
                              hide-details="auto"
                              :error-messages="formErrors.quantity"
                              label="Quantité *"
                />
              </v-col>
              <v-col cols="6" md="2">
                <v-text-field v-model="form.percentage"
                              outlined
                              dense
                              hide-details="auto"
                              :error-messages="formErrors.percentage"
                              label="Pourcentage *"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-file-input ref="image"
                              outlined
                              prepend-icon=""
                              prepend-inner-icon="mdi-upload"
                              dense
                              hide-details="auto"
                              :error-messages="formErrors.image"
                              accept="image/png, image/jpeg, image/jpg, .svg"
                              label="Image *"
                              @change="uploadFile"/>
              </v-col>
            </template>

            <!-- refill -->
            <template v-if="giftType === 'refill'">
              <v-col cols="12" md="4">
                <v-file-input ref="image"
                              outlined
                              prepend-icon=""
                              prepend-inner-icon="mdi-upload"
                              dense
                              hide-details="auto"
                              :error-messages="formErrors.image"
                              accept="image/png, image/jpeg, image/jpg, .svg"
                              label="Image *"
                              @change="uploadFile"/>
              </v-col>
              <v-col cols="12" md="8">
                <v-file-input ref="excel_file"
                              outlined
                              prepend-icon=""
                              prepend-inner-icon="mdi-file-excel-outline"
                              dense
                              hide-details="auto"
                              :error-messages="formErrors.excel_file"
                              accept=".xlsx,.xls,.csv"
                              label="Fichier Excel (Codes) *"
                              @change="uploadExcelFile"/>

                <v-alert dense
                         text
                         type="info"
                         icon="mdi-information-outline"
                         class="mt-2 mb-0"
                >
                  Le fichier doit contenir une colonne <strong>code</strong> (un code par ligne).
                </v-alert>
              </v-col>
            </template>

            <!-- BOUTONS D'ACTION -->
            <v-col cols="12" class="d-flex justify-end mt-2">
              <v-btn v-if="form.id"
                     text
                     class="mr-2"
                     @click="clear">
                <v-icon left>mdi-close</v-icon>
                Annuler
              </v-btn>
              <v-btn color="gifty"
                     :loading="btnLoading"
                     dark
                     depressed
                     @click="saveData">
                <v-icon left>{{ form.id ? 'mdi-content-save-edit' : 'mdi-check' }}</v-icon>
                {{ form.id ? 'Modifier' : 'Ajouter' }}
              </v-btn>
            </v-col>

          </v-row>


          <!-- TABLEAU -->
          <v-row class="mt-6">
            <v-col>
              <v-data-table :headers="headers"
                            :loading="isLoading"
                            class="table-border rounded-lg"
                            :items="gifts"
              >
                <template v-slot:item.status="{ item }">
                  <v-switch v-model="item.is_active"
                            class="pa-0 ma-0"
                            color="success"
                            hide-details
                            readonly
                            @click="changeStatus(item.id)"></v-switch>
                </template>

                <template v-slot:item.image="{ item }">
                  <v-avatar size="45" rounded class="my-3" v-if="item.image">
                    <v-img :src="FILE_URL + item.image"></v-img>
                  </v-avatar>
                  <span v-else></span>
                </template>

                <template v-slot:item.quantity="{ item }">
                  <strong>{{ item.quantity ?? '' }}</strong>
                </template>

                <template v-slot:item.percentage="{ item }">
                  <strong>{{ item.percentage ? item.percentage + ' %' : '' }}</strong>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="d-flex align-center">
                    <v-btn icon @click="updateItem(item)">
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon
                               v-bind="attrs"
                               v-on="on">
                          <v-icon>mdi-delete-outline</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item @click="remove(item.id)">
                          <v-list-item-avatar>
                            <v-icon color="red">mdi-trash-can</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title>Supprimer</v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-avatar>
                            <v-icon>mdi-close</v-icon>
                          </v-list-item-avatar>
                          <v-list-item-title>Annuler</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>

              </v-data-table>
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      btnLoading: false,
      isLoading: false,
      dialog: false,
      FILE_URL: process.env.VUE_APP_FILE_URL,
      gifts: [],
      giftType: "points_or_physical", // récupéré du BoostingMethod parent
      headers: [
        {
          text: 'Status',
          align: 'start',
          sortable: false,
          value: 'status',
        },
        {
          text: 'Nom',
          value: 'name',
        },
        {
          text: 'Quantité',
          value: 'quantity',
        },
        {
          text: 'Pourcentage',
          value: 'percentage',
        },
        {
          text: 'Image',
          value: 'image',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
        },
      ],
      formErrors: [],
      form: {},
      id: null,
    };
  },
  methods: {
    open(id, giftType) {
      this.id = id
      this.giftType = giftType ?? "points_or_physical"
      this.gifts = []
      this.getGifts(id)
      this.form = {
        id: "",
        boosting_method_id: id,
        name: "",
        description: "",
        quantity: "",
        percentage: "",
        image: "",
        excel_file: "",
      }

      this.resetFiles()

      this.dialog = true;
    },
    resetFiles() {
      if (this.$refs.image) {
        this.$refs.image.reset();
      }
      if (this.$refs.excel_file) {
        this.$refs.excel_file.reset();
      }
    },
    clear() {
      this.formErrors = {};
      this.form = {
        id: "",
        boosting_method_id: this.id,
        name: "",
        quantity: "",
        percentage: "",
        description: "",
        image: "",
        excel_file: "",
      }

      this.resetFiles()
    },
    close() {
      this.formErrors = {};
      this.dialog = false;
    },
    uploadFile(file) {
      this.form.image = file
    },
    uploadExcelFile(file) {
      this.form.excel_file = file
    },
    updateItem(item) {
      this.form = {
        id: item.id,
        boosting_method_id: item.boosting_method_id,
        name: item.name,
        quantity: item.quantity,
        percentage: item.percentage,
        description: item.description,
        image: "",
        excel_file: "",
      }
      this.resetFiles()
    },
    getGifts(id) {
      this.isLoading = true;
      HTTP.get("/v1/boosting-methods/gifts", {
        params: {
          boosting_method_id: id
        }
      }).then((res) => {
        this.isLoading = false;
        this.gifts = res.data.data;
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
    saveData() {
      this.formErrors = {};
      this.btnLoading = true;

      const formData = new FormData();
      formData.append("id", this.form.id ?? "");
      formData.append("boosting_method_id", this.form.boosting_method_id);
      formData.append("name", this.form.name);
      formData.append("description", this.form.description ?? "");

      if (this.giftType === 'points_or_physical') {
        formData.append("quantity", this.form.quantity);
        formData.append("percentage", this.form.percentage);
      }

      // Image commune aux deux types (points_or_physical + refill)
      if (this.form.image) {
        formData.append("image", this.form.image);
      }

      if (this.giftType === 'refill') {
        if (this.form.excel_file) {
          formData.append("excel_file", this.form.excel_file);
        }
      }

      let url = this.form.id ? "/v1/boosting-methods/gifts/update" : "/v1/boosting-methods/gifts/store"

      HTTP.post(url, formData)
          .then(() => {
            this.$successMessage = "Cet élément a été ajouté avec succès";
            this.btnLoading = false;
            this.getGifts(this.form.boosting_method_id);
            this.clear();
          })
          .catch((err) => {
            this.btnLoading = false;
            this.formErrors = err.response.data.errors;
          });
    },
    remove(id) {
      this.isLoading = true;
      HTTP.post("/v1/boosting-methods/gifts/delete", {
        id: id,
      }).then(() => {
        this.isLoading = false;
        let i = this.gifts.findIndex((el) => el.id === id);
        this.$delete(this.gifts, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
    changeStatus(id) {
      this.isLoading = true;
      HTTP.post("/v1/boosting-methods/gifts/change-status", {
        id: id,
      }).then(() => {
        this.isLoading = false;
        let index = this.gifts.findIndex(el => el.id === id)
        this.gifts[index].is_active = !this.gifts[index].is_active
        this.$successMessage = "Cet élément a été modifié avec succès.";
      }).catch((err) => {
        this.isLoading = false;
        console.log(err);
      });
    },
  },
};
</script>

<style scoped>
</style>